import api, { unauthApi } from '~/services/api';

function getPromoByCode(code: string) {
  return unauthApi.request({
    url: `/billing/promo/${code}`,
    method: 'GET',
  });
}

function applyPromoCode(code: string) {
  return api.request({
    url: `/apply_promo_code/`,
    method: 'POST',
    data: {
      code,
    },
  });
}

function replacePromoCode(code: string) {
  return api.request({
    url: `/replace_promo_code/`,
    method: 'POST',
    data: {
      code,
    },
  });
}

export { getPromoByCode, applyPromoCode, replacePromoCode };
